import { Globe } from "@/components/Svg";
import CMultiSelect from "@/components/main/form/CMultiSelect";
import Citizenships from "@/resources/citizenships.json";

const CitizenshipsInput = ({ form, dictionary }) => {
  return (
    <CMultiSelect
      // value={value}
      // onChange={setValue}
      searchable
      placeholder={dictionary.citizenships}
      className="mt-3"
      icon={<Globe />}
      data={Citizenships}
      limit={5}
      hoverOnSearchChange={true}
      filter={(value, selected, item) => {
        return (
          item.value.toLowerCase().startsWith(value.toLowerCase()) && !selected
        );
      }}
      {...form.getInputProps("citizenships")}
    />
  );
};

export default CitizenshipsInput;
